import { render } from "./ColorSchemeToggle.vue?vue&type=template&id=7b3fb638&scoped=true"
import script from "./ColorSchemeToggle.vue?vue&type=script&lang=js"
export * from "./ColorSchemeToggle.vue?vue&type=script&lang=js"

import "./ColorSchemeToggle.vue?vue&type=style&index=0&id=7b3fb638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3fb638"]])

export default __exports__